export const FAKE_ADDRESS = {
  city: 'city',
  postcode: 'postcode',
  firstname: 'firstname',
  lastname: 'lastname',
  street: ['street', '1'],
  telephone: 'telephone',
  country_code: 'pl',
}

export const INPOST_METHOD = 'standard'
export const INPOST_CARRIER = 'inpostlocker'
export const INPOST_COURIER = 'inpostcourier'
